const PROD_API_BASE_URL = 'https://api.zoonsk.melphoto.online';
const DEV_ADMIN_HOST = 'admin.dev.zoonsk.melphoto.online';

export const resolveApiBaseUrl = (
    hostname,
    explicitBaseUrl = process.env.REACT_APP_API_BASE_URL,
) => {
    const selected = explicitBaseUrl
        || (hostname === DEV_ADMIN_HOST
            ? 'https://api.dev.zoonsk.melphoto.online'
            : PROD_API_BASE_URL);
    return selected.replace(/\/+$/, '');
};

const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
export const apiBaseUrl = resolveApiBaseUrl(hostname);
export const animalApiUrl = `${apiBaseUrl}/animal`;
export const authApiUrl = `${apiBaseUrl}/auth`;
export const newsApiUrl = `${apiBaseUrl}/news`;
export const eventsApiUrl = `${newsApiUrl}/events`;
export const userApiUrl = `${apiBaseUrl}/user`;
export const questsApiUrl = `${apiBaseUrl}/quests`;
